import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

export default function Loader() {
  const [done, setDone] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let i = 0;
    const id = setInterval(() => {
      i += Math.ceil(Math.random() * 7);
      if (i >= 100) { i = 100; clearInterval(id); setTimeout(() => setDone(true), 350); }
      setCount(i);
    }, 60);
    return () => clearInterval(id);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-101%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[9999] bg-black text-white flex items-end justify-between px-6 md:px-12 pb-10"
          data-testid="page-loader"
        >
          <div>
            <p className="font-body uppercase text-xs tracking-[0.2em] text-white/60 mb-3">Sauce Studios</p>
            <p className="font-display text-3xl md:text-5xl">saucin&apos; up your content<span className="text-[#F42B29]">.</span></p>
          </div>
          <div className="font-display text-6xl md:text-9xl tabular-nums">{count.toString().padStart(2, "0")}</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
